import { render, staticRenderFns } from "./HomeText.vue?vue&type=template&id=7a628769"
import script from "./HomeText.vue?vue&type=script&lang=js"
export * from "./HomeText.vue?vue&type=script&lang=js"
import style0 from "./HomeText.vue?vue&type=style&index=0&id=7a628769&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports